import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const ModalBodyWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
}));

export const ModalBodyText = styled("span")(() => ({
  fontSize: 16,
  fontFamily: "Manrope",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.5,
  color: colors.gray800,
}));

export const ModalBodySubtext = styled("span")(() => ({
  fontSize: 16,
  fontFamily: "Manrope",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.5,
  color: colors.brandBlue600,
}));

const styles = makeStyles(() => ({
  modalWrapper: {
    width: "520px !important",
  },
}));

export default styles;
